module.exports = __webpack_public_path__ + "img/home.7ef554b5.svg";